import { FC } from "react";
import imgSrc from "../../../assets/images/bookingOnlineOverView.png";
interface MobileScreensImagesProps {}

const MobileScreensImages: FC<MobileScreensImagesProps> = () => {
  return (
    <div className="  flex justify-start  md:justify-center items-center">
      <img
        src={imgSrc}
        className=" h-[450px]  md:h-[550px] translate-x-5 md: "
        alt={"mobile screens"}
      />
    </div>
  );
};

export default MobileScreensImages;
